import { PaginaDocument } from '@next-nx/shared-graphql/vita'
import { AppTemplate } from '@next-nx/shared-ui/templates'
import { initializeApollo } from 'apps/next-vita/client'
import { NextWrapper } from 'apps/next-vita/data-fetching-wrapper'
import React from 'react'

const AppPage = ({ pagina }) => <AppTemplate pagina={pagina} />

export const getServerSideProps = NextWrapper.getServerSideProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PaginaDocument,
    variables: {
      chiave: 'landing-app',
    },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina }, // will be passed to the page component as props
    // In seconds
  }
})

export default AppPage
